module.exports = __webpack_public_path__ + "static/assets/ac68130562b199a7a7b81345e9200cd5.svg";